import { useSelector } from 'react-redux';
import AppLayout from '../components/global/layout/Layout.jsx';
import { Navigate, useParams } from 'react-router-dom';

const ProtectedRoute = ({ type, children, ib, title, parent, ...rest }) => {

    const { loggedIn } = useSelector(state => state.user);
    const { userDetails } = useSelector(state => state.user);
    const params = useParams();
    let mainParent = parent
    if (parent) {
        mainParent = parent.map(item => ({ ...item, path: item.path.replace(':id', params.id) }))
    }
    if (type === "private") {

        if (loggedIn) {
            // if (rest?.isProfileCompleted && !userDetails.clientVerify && rest?.path !== 'client_profile') {
            //     return <Navigate to="/client_profile" replace />
            // }
            if (userDetails?.status === 'Approved') {
                if (ib === 'parent') { return children }
                if (ib === 'ib') {
                    if (userDetails?.ibRole == "IBUser") {
                        return <AppLayout ib={true} title={title} parent={mainParent}>{children}</AppLayout>
                    }
                    return <Navigate to="/" replace />
                }
                return <AppLayout ib={false} title={title} parent={mainParent}> {children} </AppLayout>
            }
            else {
                return <Navigate to="/kyc" replace />
            }
        } else {
            return <Navigate to="/" replace />
        }

    }
    if (type === "kyc") {
        if (loggedIn) {
            return <AppLayout ib={false} title={title} parent={mainParent}>{children}</AppLayout>
        } else {
            return <Navigate to="/" replace />
        }
    }
    if (type === "public") {
        return children;
    }
    if (type === "auth") {
        if (!loggedIn) {
            return children;
        } else {
            // if (userDetails?.clientVerify === false) {
            //     return <Navigate to="/client_profile" replace />
            // } else {
            return <Navigate to="/dashboard" replace />;
            // }

        }
    }
    return;
}

export default ProtectedRoute;